import { createSlice } from '@reduxjs/toolkit';

const deviceModeSlice = createSlice({
    name: 'deviceMode',
    initialState: {},
    reducers: {
        setDeviceMode: (state, action) => {
            return action.payload;
        }
    }
});

export const { setDeviceMode } = deviceModeSlice.actions;
export default deviceModeSlice.reducer;